const home = () => '/home';
const login = () => '/login';
const signup = () => '/signup';
const entities = () => '/entities';
const entity = (slug: string) => `/entities/${slug}`;
const entityUpsert = () => `/entities/create`;
const itemUpsert = (entitySlug: string, itemId: string) => `/entities/${entitySlug}/items/${itemId}`;
const notifications = () => '/notifications';
const objectives = () => '/objectives';
const objective = (slug: string) => `/objectives/${slug}`;
const organizations = () => '/organizations';
const organization = (slug: string) => `/organizations/${slug}`;
const projects = () => '/projects';
const project = (slug: string) => `/projects/${slug}`;
const settings = (section?: string) => (
  section ? `/settings/${section}` : '/settings'
);
const search = (query?: string) => {
  if (query) {
    return `/search?q=${encodeURIComponent(query)}`;
  }
  return '/search';
};
const tasks = () => '/tasks';
const task = (slug: string) => `/tasks/${slug}`;
const templates = () => '/templates';
const template = (slug: string) => `/templates/${slug}`;
const templateUpsert = () => `/templates/create`;
const admin = () => '/admin';
const users = () => `${admin()}/users`;
const features = () => `${admin()}/features`;
const timesheet = (filter: { [key: string]: any; } = {}) => {
  if (filter.date) {
    return `/timesheet?date=${filter.date}`;
  }
  return '/timesheet';
};

const paths = {
  admin: admin(),
  home: home(),
  login: login(),
  signup: signup(),
  entities: entities(),
  entity: entity(':slug'),
  entityUpsert: entityUpsert(),
  itemUpsert: itemUpsert(':entitySlug', ':itemId'),
  notifications: notifications(),
  objectives: objectives(),
  objective: objective(':slug'),
  organizations: organizations(),
  organization: organization(':slug'),
  projects: projects(),
  project: project(':slug'),
  search: search(),
  settings: settings(),
  settingsSection: settings(':section'),
  tasks: tasks(),
  task: task(':slug'),
  templates: templates(),
  template: template(':slug'),
  templateUpsert: templateUpsert(),
  timesheet,
  users: users(),
  features: features(),
};

const links = {
  admin: () => admin(),
  home,
  login: () => login(),
  signup: () => signup(),
  entities: () => entities(),
  entity: (slug: string) => entity(slug),
  entityUpsert: () => entityUpsert(),
  itemUpsert: (entitySlug: string, itemId: string) => itemUpsert(entitySlug, itemId),
  notifications: () => notifications(),
  objectives: () => objectives(),
  objective: (slug: string) => objective(slug),
  organizations: () => organizations(),
  organization: (slug: string) => organization(slug),
  projects: () => projects(),
  project: (slug: string) => project(slug),
  search,
  settings: (section?: string) => settings(section),
  tasks: () => tasks(),
  task: (slug: string) => task(slug),
  templates: () => templates(),
  template: (slug: string) => template(slug),
  templateUpsert: () => templateUpsert(),
  timesheet,
  users: () => users(),
  features: () => features(),
  paths,
};

export const linkKey = (resource?: { id?: string; slug?: string } | null) => (
  resource?.slug || resource?.id || ''
);

export const matchesLinkKey = (
  resource: { id?: string; slug?: string },
  key?: string,
) => Boolean(key) && (resource.slug === key || resource.id === key);

export default links;
